<template>
    <span class="badge" :class="badgeClass">{{status | registrationCategoryStatus}}</span>
</template>

<script>
    import {registrationCategoryStatus} from '../RegistrationCategories/filters/registration_category_status'

    export default {
        name: "StatusBadge",
        props: {
            status: {
                required: true,
                type: String,
            },
        },
        filters: {
            registrationCategoryStatus,
        },
        computed: {
            badgeClass() {
                switch (this.status) {
                    case "human_status_closed":
                        return "badge-danger";
                    case "human_status_open":
                        return "badge-success";
                    case "human_status_full":
                        return "badge-danger";
                    case "human_status_waiting_list":
                        return "badge-warning";
                    case "human_status_inactive":
                        return "badge-secondary";
                    default:
                        return "bade-secondary";
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .badge {
        display: inline;
        padding: .2em .6em .3em;
        font-size: 75%;
        font-weight: 700;
        line-height: 1;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: .25em;

        &.badge-success {
            background: #00a65a !important;
        }

        &.badge-danger {
            background: #dd4b39 !important;
        }

        &.badge-warning {
            background: #94cf22;
        }
    }
</style>



// WEBPACK FOOTER //
// src/Assets/components/Participants/StatusBadge.vue